import { AbstractViewStore } from '@coach-bot/data-access/shared/stores/abstract/abstract-view.store';
import { LocalStorageService } from '../services';

export class CoachBotViewStore extends AbstractViewStore {
  constructor(protected localStorageService: LocalStorageService) {
    super(localStorageService);
  }
}
